import { EpimsBaseEntityDto } from './epim-base.dto';
export class MeasureDto extends EpimsBaseEntityDto {

    MeasureId: string;

    MeasureName: string;
    
    SubscriptionUserId: string;
    GroundRentAmount: string;
    Status: string;
    length: number;
}